import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const ProfileModule = React.lazy(() => import("./ProfileModule"));

export const ProfileModuleRoutes: RouteObject = {
  path: "account",
  element: <ModuleRoute El={ProfileModule} moduleName="profile" />,
};
